module.exports = __webpack_public_path__ + "img/logo_header_mobile.1288b3c8.png";